import React from 'react';
import createReactClass from 'create-react-class';

const NullPlaceholder = createReactClass({
  render() {
    return null;
  },
});

export default (components, options = {}) => {
  const nextComponents = new Array(...components);

  const optionsWithDefaults = Object.assign(
    {},
    {placeholder: NullPlaceholder, multipleOf: 4, minimum: 0, props: {}},
    options
  );

  const {placeholder: Placeholder, multipleOf, minimum, props} = optionsWithDefaults;
  const neededComponents = Math.ceil(nextComponents.length / multipleOf) * multipleOf;
  const totalComponents = (neededComponents >= minimum) ? neededComponents : minimum;
  const placeholdersNeeded = totalComponents - nextComponents.length;

  for (let i = 0; i < placeholdersNeeded; i++) {
    nextComponents.push(<Placeholder key={`placeholder-${i}`} {...props} />);
  }


  return nextComponents;
};



// WEBPACK FOOTER //
// ./app/javascript/utils/components/fillWithPlaceholders.js